	<!-- Modal Agregar Productos -->

<app-navbar></app-navbar>

<div class="estadias-container">
	
	
	<app-detail (hostingSelected)="onHostingSelectedFromDetail($event)"></app-detail>
	<h1 class="estadias-title"> Estadias disponibles: </h1>
	
	<div *ngIf="error" class="estadias-error">{{ error }}</div>
	<div *ngIf="!loading && estadias.length === 0 && !error" class="estadias-empty">No hay estadías registradas.</div>
	<div class="estadias-list">
		<div *ngFor="let reservation of paginatedReservas" class="estadia-card">
			<div class="estadia-header">
				<span class="estadia-hotel">{{reservation.accommodationName.value}}</span>
				<span class="estadia-status" [ngClass]="{
					'iniciada': reservation.status === 'Iniciada',
					'finalizada': reservation.status === 'Finalizada',
					'pendiente': reservation.status === 'Pendiente'
				}">{{ reservation.status }}</span>
			</div>

			<div class="estadia-body">
				<div><strong>Tipo de alojamiento:</strong> {{reservation.accommodationType}}</div>
				<div><strong>Habitación:</strong> {{reservation.roomtype}} (N° {{reservation.roomnumber}})</div>
				<div><strong>Check-in:</strong> {{ reservation.check_in | date:'mediumDate' }}</div>
				<div><strong>Check-out:</strong> {{ reservation.check_out | date:'mediumDate' }}</div>
				<div><strong>Total:</strong> ${{reservation.payment.total_value}}</div>
			</div>
			<div class="estadia-actions">
				<!-- <button (click)="verDetalles(estadia)" class="btn btn-details">Ver Detalles</button> -->
				<button *ngIf="reservation.status === 'None'" (click)="agregarProductos(reservation)" class="btn btn-add-products">Agregar Productos</button>				
				<button *ngIf="reservation.status === 'Pendiente'" (click)="pagarProductos(reservation)" class="btn btn-pay-products">Pagar Productos</button>
				<button *ngIf="reservation.status === 'Pendiente'" (click)="abrirModalFinalizar(reservation)" class="btn btn-finish">Finalizar Estadía</button>				
			</div>
		</div>

		<!-- Modal Agregar Productos -->
		<div class="modal-overlay" *ngIf="mostrarModalAgregar">
			<div class="modal">
				<h3>Agregar Productos a la estadía</h3>
				<p><strong>Hotel:</strong> {{ estadiaSeleccionada?.hotel_name || estadiaSeleccionada?.hotelId }}</p>
				<p><strong>Habitación:</strong> {{ estadiaSeleccionada?.room_name || estadiaSeleccionada?.roomId }}</p>

				<div class="productos-lista">
					<table>
						<thead>
							<tr>
								<th>Nombre</th>
								<th>Precio</th>
								<th>Disponible</th>
								<th>Cantidad</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let p of productosDisponibles">
								<td>{{ p.name }}</td>
								<td>{{ p.price | currency }}</td>
								<td>{{ p.stock }}</td>
								<td>
									<input type="number" min="0" [(ngModel)]="productosSeleccionados[p.productId]" />
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div class="modal-actions">
					<button class="btn-small btn-danger" (click)="confirmarAgregarProductos()">✔️ Confirmar</button>
					<button class="btn-small" (click)="cerrarModalAgregar()">Cancelar</button>
				</div>
			</div>
		</div>

		<!-- Modal Pagar Productos -->
		<div class="modal-overlay" *ngIf="pagarModalVisible">
			<div class="modal">
				<h3>Pagar Productos</h3>

				<div *ngIf="loadingProductos">Cargando productos...</div>
				<div *ngIf="!loadingProductos && productosPendientes.length === 0">
					<p>No hay productos pendientes de pago para esta estadía.</p>
				</div>

				<table *ngIf="productosPendientes.length > 0">
					<thead>
						<tr>
							<th>Producto</th>
							<th>Cantidad</th>
							<th>Precio Unitario</th>
							<th>Total</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let p of productosPendientes">
							<td>{{ p.name }}</td>
							<td>{{ p.quantity }}</td>
							<td>{{ p.unit_price | currency }}</td>
							<td>{{ p.total_price | currency }}</td>
						</tr>
					</tbody>
				</table>

				<!-- Métodos de pago -->
				<div class="payment-methods" *ngIf="productosPendientes.length > 0">
					<h4>Método de pago</h4>
					<label>
						<input
							type="radio"
							name="paymentMethod"
							value="billetera digital"
							[(ngModel)]="selectedPaymentMethod"
						/>
						Billetera Digital
					</label>
					<label>
						<input
							type="radio"
							name="paymentMethod"
							value="efectivo"
							[(ngModel)]="selectedPaymentMethod"
						/>
						Efectivo
					</label>

					<div class="selected-method" *ngIf="selectedPaymentMethod">
						<small>Método seleccionado: 
							<strong>{{ selectedPaymentMethod | titlecase }}</strong>
						</small>
					</div>
				</div>

				<div class="modal-actions">
					<button
						class="btn-small btn-primary"
						[disabled]="!selectedPaymentMethod || productosPendientes.length === 0"
						(click)="confirmarPagoProductos()"
					>
						💳 Pagar
					</button>
					<button class="btn-small" (click)="cerrarModalPago()">Cancelar</button>
				</div>
			</div>
		</div>

		<!-- Modal Finalizar Estadía -->
		<div class="modal-overlay" *ngIf="finalizarModalVisible">
			<div class="modal">
				<h3>Finalizar Estadía</h3>

				<div *ngIf="loadingFinalizar">Cargando productos...</div>

				<div *ngIf="!loadingFinalizar">
					<p><strong>Hotel:</strong> {{ estadiaSeleccionada?.hotel_name || estadiaSeleccionada?.hotelId }}</p>
					<p><strong>Habitación:</strong> {{ estadiaSeleccionada?.room_name || estadiaSeleccionada?.roomId }}</p>

					<h4>Productos de la estadía</h4>
					<table *ngIf="productosEstadia.length > 0">
						<thead>
							<tr>
								<th>Producto</th>
								<th>Cantidad</th>
								<th>Total</th>
								<th>Estado</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let p of productosEstadia">
								<td>{{ p.name }}</td>
								<td>{{ p.quantity }}</td>
								<td>{{ p.total_price | currency }}</td>
								<td [ngClass]="{ 'pendiente': p.status === 'pendiente', 'pagado': p.status === 'pagado' }">
									{{ p.status | titlecase }}
								</td>
							</tr>
						</tbody>
					</table>

					<div *ngIf="productosEstadia.length === 0">
						<p>No se han agregado productos a esta estadía.</p>
					</div>

					<div class="modal-actions">
						<button class="btn-small btn-finish"
										[disabled]="tienePendientes"
										(click)="confirmarFinalizarEstadia()">
							✅ Confirmar Finalización
						</button>
						<button class="btn-small" (click)="cerrarModalFinalizar()">Cancelar</button>
					</div>

					<div *ngIf="tienePendientes" class="warning-msg">
						⚠️ No se puede finalizar la estadía porque hay productos pendientes de pago.
					</div>
				</div>
			</div>
		</div>

	</div>
</div>

<app-footer></app-footer>